import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLButtonElement> {
  static targets = ['inputWrapper']

  declare inputWrapperTarget: HTMLDivElement

  populatorClick(e: MouseEvent): void {
    const input = this.inputWrapperTarget.querySelector('input')
    const button = e.currentTarget as HTMLButtonElement
    const textToPopulate = button.dataset.textToPopulate ?? null

    if (input !== null && textToPopulate !== null) {
      input.value = textToPopulate
    }
  }
}
